import React, { useEffect, useState } from "react";
import {
  DesktopOutlined,
  FileOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { IoNotifications } from "react-icons/io5";

import {
  Layout as AntdLayout,
  Breadcrumb,
  Layout,
  Menu,
  Dropdown,
  Avatar,
  message,
  Button,
  Tooltip,
} from "antd";
import { NavLink, useLocation } from "react-router-dom";
import _ from "lodash";

import "./layout.less";
import Logo from "@assets/images/logoD.png";
import LogoM from "@assets/images/logoM.png";
import { ReactComponent as Down } from "@assets/images/arrow-down.svg";
import { IConfig, client_config, admin_config } from "./sidebar-config";
import profilePic from "@assets/images/avatar.png";
import { useTypedSelector } from "@hooks";
import CompCoreLogo from "@assets/images/compcoreDark.png";

import {
  ErrorServices,
  loadRefreshToken,
  // useFetchCompanyJobGradesQuery,
  useLogoutMutation,
} from "@services";
import { checkPermission, isAdmin } from "@utils";
import customErrorMessage from "../CustomErrorMessage";

const ssoUrl = "";
const appsPageUrl = "/#/app";

const { Header, Content, Footer, Sider } = Layout;

const { SubMenu } = Menu;

const App = ({ children }: { children: React.ReactNode }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [currentPath, setCurrentPath] = useState<string>("/app");
  const { user } = useTypedSelector(state => state.auth);

  const { id: company_id, large_logo_url } = user?.company || {};
  const [isMenuVisible, setIsMenuVisible] = React.useState(false);
  const [onLogout] = useLogoutMutation();
  const { pathname } = useLocation();

  const config = isAdmin(user?.role!)
    ? admin_config(company_id?.toString() || "1", `${user?.role}`)
    : client_config(
        [
          {
            grade: "",
            type: null,
            country_ids: [1],
            countries: [
              {
                id: 1,
                name: "",
              },
            ],
            id: 1,
            is_global: true,
          },
        ],
        company_id?.toString() || "1",
        `${user?.role}`
      );

  // const config = client_config(
  //   [
  //     {
  //       grade: "",
  //       type: null,
  //       country_ids: [1],
  //       countries: [
  //         {
  //           id: 1,
  //           name: "",
  //         },
  //       ],
  //       id: 1,
  //       is_global: true,
  //     },
  //   ],
  //   company_id?.toString() || "1",
  //   `${user?.role}`
  // );

  const handleLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    path: string,
    disabled?: boolean,
    fallbackMessage?: string,
    finalPath?: string
  ) => {
    setCurrentPath(finalPath || "");
    if (disabled) {
      event.preventDefault();
      customErrorMessage(fallbackMessage || "Access Denied");
    }
  };

  const normalizePath = (p: string): string =>
    p.split("/:")[0].replace(/\/+$/, "").toLowerCase();

  const isRouteMatch = (
    matchPaths: string[] = [],
    currentPath: string
  ): boolean => {
    return matchPaths.some(
      p => normalizePath(p) === normalizePath(currentPath)
    );
  };

  const isSubLinkActive = (currentPath: string, subPath: string): boolean => {
    const base = normalizePath(subPath);
    return normalizePath(currentPath).startsWith(base);
  };

  const isSubAnyActive = (
    subLinks: IConfig[] | undefined,
    currentPath: string
  ) => subLinks?.some(sub => isSubLinkActive(currentPath, sub.path)) ?? false;

  const onLogoutFromServer = async () => {
    try {
      const refresh = loadRefreshToken();
      await onLogout({ refresh }).unwrap();
      window.open(ssoUrl, "_self"); // open SSO page after logout
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const openAppsPage = () => {
    window.open(appsPageUrl, "_self");
  };

  useEffect(() => {
    setCurrentPath(pathname);
  }, [pathname]);
  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={openAppsPage}>
        Apps
      </Menu.Item>
      <Menu.Item key="2" onClick={onLogoutFromServer}>
        Log out
      </Menu.Item>
    </Menu>
  );

  let colorBgContainer = "red";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        onCollapse={value => setCollapsed(value)}
        className="bg-themeCore shadow-md z-50"
        width={280}
      >
        <div className="demo-logo-vertical" />
        <div className="mb-6">
          <img
            onClick={() => setCollapsed(!collapsed)}
            src={collapsed ? LogoM : Logo}
            className=" w-full h-full px-4 py-4 cursor-pointer"
          />
        </div>
        <div>
          {config.map((item: IConfig, idx: number) => {
            const subActive = isSubAnyActive(item.sub, currentPath);
            const selfActive = isRouteMatch(
              item.matchPaths ?? [item.path],
              currentPath
            );
            const isActive = selfActive && !subActive;

            return (
              <div className="px-4" key={idx}>
                {/* Parent NavLink */}
                <Tooltip
                  title={collapsed ? item.title : ""}
                  placement="right"
                  mouseEnterDelay={0.3}
                >
                  <NavLink
                    exact
                    to={item.path}
                    className={`group flex items-center w-full py-3 px-3 mt-2 rounded transition-all delay-[1ms]
      hover:bg-themeBlue hover:text-white
      ${isActive ? "bg-themeBlue text-white" : "text-themeGrey"}
      ${collapsed ? "justify-center" : ""}`}
                    onClick={event =>
                      handleLinkClick(
                        event,
                        item.path,
                        item.disabled,
                        item.fallbackMessage,
                        item.path
                      )
                    }
                  >
                    <div className={collapsed ? "" : "mr-4"}>
                      <item.icon className="group-hover:text-white" />
                    </div>

                    {!collapsed && <p>{item.title}</p>}
                  </NavLink>
                </Tooltip>

                {/* Sub NavLinks */}
                {item.sub?.map((sub, i) =>
                  checkPermission(sub.permission) ? (
                    <Tooltip
                      key={i}
                      title={collapsed ? sub.title : ""}
                      placement="right"
                      mouseEnterDelay={0.3}
                    >
                      <NavLink
                        to={sub.path}
                        className={`group flex items-center w-full py-2 px-3 mt-1 rounded transition-all delay-[1ms]
          hover:bg-themeBlue hover:text-white
          ${
            isSubLinkActive(currentPath, sub.path)
              ? "bg-themeBlue text-white"
              : "text-themeGrey"
          }
          ${collapsed ? "justify-center" : "ml-3"}`}
                        onClick={event => handleLinkClick(event, sub.path)}
                      >
                        <div className={collapsed ? "" : "mr-4"}>
                          <sub.icon className="group-hover:text-white" />
                        </div>

                        {!collapsed && <p>{sub.title}</p>}
                      </NavLink>
                    </Tooltip>
                  ) : null
                )}
              </div>
            );
          })}
        </div>

        {/* <div className="absolute bottom-10 items-center justify-center flex w-full">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
        </div> */}
      </Sider>
      <Layout>
        <Header className="bg-white flex justify-end items-center z-50">
          {/* <div className="notification relative mr-4">
            <div
              style={{
                backgroundColor: "#00519d",
              }}
              className="notificationDot rounded-full  p-1 w-1 h-1 absolute top-0 right-1 border-2"
            ></div>
            <div className="bell">
              <IoNotifications
                style={{
                  color: "#6b6d70",
                }}
                className="text-3xl "
              />
            </div>
          </div> */}
          <div className="flex justify-end">
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <div
                className="
            flex
            items-center
            gap-2
            px-2
            py-1
            rounded-full
            bg-themeGrey
            cursor-pointer
            hover:shadow-sm
            transition-all
          "
              >
                <Avatar size={38} src={large_logo_url || profilePic} />

                <span
                  className="text-sm font-medium"
                  style={{ color: "#6B6B6B" }}
                >
                  {`${user?.first_name} ${user?.last_name}`}
                </span>

                <Down
                  style={{
                    width: 12,
                    height: 12,
                  }}
                />
              </div>
            </Dropdown>
          </div>
        </Header>

        <Content
          style={{
            padding: pathname !== "/app" ? "20px 16px" : undefined,
            width: "100%",
            height: "calc(100vh - 64px)",
            background: "white",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
              {children}
            </div>

            {pathname !== "/app" && (
              <footer className="flex-shrink-0 flex justify-end items-center mr-16 py-2 bg-white">
                <div className="compcore w-52 object-contain">
                  <img src={CompCoreLogo} alt="" />
                </div>
              </footer>
            )}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
